
import React from 'react';
import HeroContent from './hero/HeroContent';
import HeroVideo from './hero/HeroVideo';
import HeroDecorations from './hero/HeroDecorations';
import { useBreakpoint } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

const Hero = () => {
  const { isMobile } = useBreakpoint();
  
  return (
    <section 
      className={cn(
        'min-h-[90vh] md:min-h-screen relative overflow-hidden',
        'bg-gradient-to-b from-[#003a70]/5 to-white',
        isMobile ? 'pt-16 pb-12' : 'pt-28 pb-16'
      )}
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <HeroContent />
        <HeroVideo />
      </div>
      <HeroDecorations />
    </section>
  );
};

export default Hero;
